// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#move-room-schedule-edit .note[data-v-219d91c6]{margin:0 0 20px 20px}#move-room-schedule-edit .box-footer[data-v-219d91c6]{padding:10px 0 0 0!important}#move-room-schedule-edit .cancel-btn[data-v-219d91c6],#move-room-schedule-edit .edit-btn[data-v-219d91c6]{width:120px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
